
const projectFilter = document.querySelectorAll('.project-filter');
const projectFilterActiveClassName = 'project-filter--active';

projectFilter.forEach(item => {
    const filter = item.querySelector('.project-filter__item');

    // Open the filter on click.
    filter.addEventListener('click', e => {
        const isActive = filter.parentElement.classList.contains(projectFilterActiveClassName) || filter.matches(':hover');
        if (isActive) return;

        filter.parentElement.classList.add(projectFilterActiveClassName);
        e.preventDefault();
    });

    // Close the filter when focus moves out of it.
    filter.addEventListener('focusout', e => {
        if (filter.contains(e.relatedTarget)) return;
        filter.parentElement.classList.remove(projectFilterActiveClassName);
    });

});
